import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "72px", marginBottom: "10px" }}>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for doesn’t exist or was moved.</p>

        <Link to="/" className="btn btn-primary mt-3">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
